import React, { useState, useEffect } from 'react';
import { extractWorkbook, extraerDatosInventarioCampoExcel } from '../../../sharecomponents/ExcelUtilities';
import TableHeadsData from './tableHeadsData';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import vr from '../../../../utils/Verifiers';

const CargarDiccionarioTuneles = () => {

    const [excelData, setexcelData] = useState({ workbook: undefined, hojas: [], hoja: "" });
    const [loader, setloader] = useState(false);
    const [encabezados, setencabezados] = useState([]);
    const [datos, setdatos] = useState([]);
    const [libres, setlibres] = useState([]);
    const [showLibres, setshowLibres] = useState(false);
    const [message, setmessage] = useState("");
    const [tipo, settipo] = useState(false);
    const [dialog, setdialog] = useState({ show: false });
    useEffect(() => {

    }, []);

    const loadWorbook = (e) => {
        settipo(false);
        setloader(true);
        extractWorkbook(e, setexcelData, setloader);
    }

    const loadsheet = async (e) => {
        settipo(false);
        let hoja = e.target.value;
        let data = { ...excelData };
        data.hoja = hoja;
        setloader(true);
        setexcelData(data);
        let response = await extraerDatosInventarioCampoExcel(data);
        //'encabezados': titulos, 'data': dataResp, 'tipo': 'campo'
        setloader(false);
        settipo(response.tipo);
        setencabezados(response.encabezados);
        console.log(response.data);
        setdatos(response.data);
        setshowLibres(false);
        setlibres(response.tipo == 'campo' ? [] : []);
        setexcelData({ workbook: excelData.workbook, hojas: excelData.hojas, hoja: "" });
    }

    async function guardarNube() {
        if (datos.length === 0) return;
        const resp = await vr.getDataAPI('campo/v2/inventario_campo/match_vivero', { data: datos }, setloader, setdialog);
        if (!resp.estatus) return;
        vr.activeDialog(setdialog, resp.msj, 'ACCIÓN EXITOSA', 'success');
    }

    return (
        <div className="bg-white border round-bottom-m shadow-xl p-3 m-0" style={{ maxHeight: '76vh', overflow: 'auto' }}>
            <div className='row justify-content-center  m-0 p-0'>
                <div className='col-lg-12'>
                    <div className='row justify-content-center m-0 p-0 mb-3'>
                        <div className='form-group mt-2' style={{ width: '300px' }}>
                            <label className="text-success text-bold  nowrap">Seleccionar archivo excel</label>
                            <input type='file' className='form-control form-control-sm' onChange={loadWorbook}
                                placeholder='Cargar archivo'
                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
                        </div>

                        <div className='form-group mt-2' style={{ width: '250px' }}>
                            {excelData.hojas && excelData.hojas.length > 0 && <>
                                <label className="text-success text-bold  nowrap">Seleccionar hoja</label>
                                <select className='form-control form-control-sm' placeholder='' value={excelData.hoja ?? ""} onChange={loadsheet}>
                                    <option value='' >Seleccione una</option>
                                    {
                                        excelData.hojas.map((hoja) => {
                                            return (
                                                <option key={"hoja" + hoja} value={hoja}>{hoja}</option>
                                            )
                                        })
                                    }
                                </select>
                            </>
                            }
                        </div>

                        <div className='form-group contenedor align-items-end p-0 m-0 mt-4' style={{ width: '250px' }}>
                            {datos.length > 0 &&
                                <button type="button" className="btn btn-sm btn-success m-2 shadow" onClick={() => guardarNube()} disabled={loader || datos.length === 0}>
                                    <i className="fa fa-save mr-2" aria-hidden="true"></i>
                                    GUARDAR INFORMACIÓN
                                </button>
                            }
                        </div>

                    </div>
                </div>
                {message.msj && <div className='col-lg-12 text-center text-l text-300'>{message} </div>}
                {(false && showLibres && libres.length > 150 || !showLibres && datos.length > 150) && <div className='w-100 text-s text-center text-bold text-red3'>
                    Se muestran 150 registros de {showLibres ? libres.length : datos.length} registros que contiene el archivo
                </div>}
                {datos && datos.length > 0 && <TableHeadsData data={datos.slice(0, 200)} heads={encabezados} styleName={{ width: '100% !important', height: '63vh' }} />}
            </div>
            {loader && <div className='blur-s' style={{ width: '100vw', height: '100vh', position: 'fixed', left: 0, top: 0 }}><div className='loader'></div></div>}
            <VainillaDialog data={dialog} />
        </div>
    )
}

export default CargarDiccionarioTuneles;